module.exports = "/_next/static/images/buyers_8_en-0a989ab59f928802682133947634d6a9.png";